export class ExpressTestUpdateIndicatorDto {
    laboratoryIndicatorCode: string;
    postHandleValue: number;
    value: number;
}